import React, { useEffect, useState } from 'react';
import MarketService, { MarketInfo } from '../../services/MarketService';
import './MarketSelector.css';

export interface MarketSelectorProps {
  onMarketSelect?: (market: MarketInfo) => void;
  detectedMarketId?: 'uk' | 'texas';
}

export const MarketSelector: React.FC<MarketSelectorProps> = ({
  onMarketSelect,
  detectedMarketId,
}) => {
  const [markets, setMarkets] = useState<MarketInfo[]>([]);
  const [recommendedId, setRecommendedId] = useState<'uk' | 'texas'>('uk');

  useEffect(() => {
    const list = MarketService.getAvailableMarkets();
    setMarkets(list);

    const rec = detectedMarketId || MarketService.detectGeoMarket();
    setRecommendedId(rec);
  }, [detectedMarketId]);

  const handleSelect = (market: MarketInfo) => {
    MarketService.setStoredMarket(market.id);
    if (onMarketSelect) {
      onMarketSelect(market);
    } else {
      MarketService.redirectToMarket(market.id);
    }
  };

  return (
    <div className="market-selector" data-testid="market-selector">
      <div className="market-cards-grid" data-testid="market-cards-grid">
        {markets.map((market) => {
          const isRecommended = market.id === recommendedId;
          return (
            <div
              key={market.id}
              className={`market-card ${isRecommended ? 'recommended' : ''}`}
              data-testid={`market-card-${market.id}`}
            >
              {isRecommended && (
                <div className="recommended-badge" data-testid="recommended-badge">
                  Recommended for your location
                </div>
              )}

              <div>
                <div className="market-card-header">
                  <span className="market-flag">{market.flagEmoji}</span>
                  <div>
                    <h3 className="market-title">{market.name}</h3>
                    <span className="market-code">{market.currency} ({market.currencySymbol})</span>
                  </div>
                </div>

                <div className="market-framework" data-testid={`market-framework-${market.id}`}>
                  {market.framework}
                </div>

                <p className="market-description">{market.description}</p>

                <ul className="market-features-list">
                  {market.features.map((feature, idx) => (
                    <li key={idx}>{feature}</li>
                  ))}
                </ul>
              </div>

              <div className="market-card-footer">
                <button
                  type="button"
                  className="market-btn"
                  onClick={() => handleSelect(market)}
                  data-testid={`launch-btn-${market.id}`}
                >
                  Launch {market.name} Market
                </button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default MarketSelector;
